import React, { ChangeEvent } from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/new-trash-green.svg'
import { Procedure } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import * as S from './styles'

type ProcedureCardProps = {
  procedure: Procedure
  handleQuantityChange?: (
    code: number,
    e: ChangeEvent<HTMLInputElement>
  ) => void
  handleQuantityBlur?: (code: number, e: ChangeEvent<HTMLInputElement>) => void
  removeProcedure?: (code: number) => void
}

export const ProcedureCard = ({
  procedure,
  handleQuantityChange,
  handleQuantityBlur,
  removeProcedure
}: ProcedureCardProps) => {
  return (
    <CardNew key={procedure?.code} style={{ width: '100%' }} shadow="satin">
      <S.CardHeader>
        <SupportTextNew color="neutral500" size="xsmall" weight="bold">
          {procedure?.name}
        </SupportTextNew>
        {removeProcedure && (
          <S.TrashContainer onClick={() => removeProcedure(procedure?.code)}>
            <TrashIcon width="24" height="24" />
          </S.TrashContainer>
        )}
      </S.CardHeader>

      <DividerNew marginTop="8px" marginBottom="16px" />

      <S.CardContent>
        <S.Row>
          <div>
            <TextFieldNew
              label="Código TUSS"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              // style={{ width: '140px' }}
              value={procedure?.code}
              disabled
            />
          </div>

          <div>
            <TextFieldNew
              label="Quantidade"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              type="number"
              // style={{ width: '80px' }}
              value={procedure.quantity || ''}
              onChange={(e) =>
                handleQuantityChange && handleQuantityChange(procedure?.code, e)
              }
              onBlur={(e) =>
                handleQuantityBlur && handleQuantityBlur(procedure?.code, e)
              }
              min={1}
              max={100}
              disabled={!handleQuantityChange}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
        </S.Row>
      </S.CardContent>
    </CardNew>
  )
}
